// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"styles_cardWrapper__M_eH0","cardBody":"styles_cardBody__VIhqT","printBlock":"styles_printBlock__eOrIg"};